import React, { Component } from "react";
import styled from "styled-components";
import SearchBox from "../SearchBox/SearchBox";
import LocateMeButton from "../LocateMeButton/LocateMeButton";
import RestaurantList from "../RestaurantList/RestaurantList";
import RestaurantDetail from "../RestaurantDetail/RestaurantDetail";
import GoogleMap from "../GoogleMap/GoogleMap";
import { Marker, DirectionsRenderer } from "google-maps-react";
import Markers from "../Marker/Markers";
import MAP_STYLE from "../../const/map_style.json";
import MAP_STYLE_MOBILE from "../../const/map_style_mobile.json";
import TORONTO_CENTER from "../../const/toronto_center";
import MARKER_ICON from "../../const/corona-bottle.png";
import { restaurantData } from "../../const/restaurants-official.js";
// import { DirectionsRenderer } from "react-google-maps";

const Wrapper = styled.div`
  height: calc(100vh);
`;

function importAll(r) {
  return r.keys().map(r);
}

class PatioFinder extends Component {
  constructor(props) {
    super(props);
    this.resetSelectedLocation = this.resetSelectedLocation.bind(this);
    this.updateLocation = this.updateLocation.bind(this);
    this.updateBounds = this.updateBounds.bind(this);
    this.onRestaurantSelect = this.onRestaurantSelect.bind(this);
    this.getSelectedRestaurantId = this.getSelectedRestaurantId.bind(this);
    this.resetSelectedRestaurantId = this.resetSelectedRestaurantId.bind(this);
    this.openLink = this.openLink.bind(this);
    this.onClose = this.onClose.bind(this);
    this.setDestinationAndClose = this.setDestinationAndClose.bind(this);

    this.restaurantListings = null;

    this.state = {
      lat: TORONTO_CENTER.lat,
      lng: TORONTO_CENTER.lng,
      selectedLocation: null,
      center: { lat: TORONTO_CENTER.lat, lng: TORONTO_CENTER.lng },
      selectedRestaurant: null,
      selectedRestaurantId: null,
      origin: null,
      destination: null,
      restaurantsInBounds: []
    };
  }

  componentWillMount() {
    this.position();
    const restaurantImages = importAll(
      require.context(
        "../../const/restaurant-images",
        false,
        /\.(png|jpe?g|svg)$/
      )
    );

    restaurantImages.forEach((imgUrl, i) => {
      var id = parseInt(imgUrl.split("-")[0].split("/")[3]);
      restaurantData[id - 1].imageUrl = imgUrl;
    });

    // get active listings
    this.restaurantListings = restaurantData.filter(function(obj) {
      return obj.active === true;
    });

    // remove listings without images
    this.restaurantListings = this.restaurantListings.filter(function(obj) {
      return obj.imageUrl !== null;
    });
    // console.log(this.restaurantListings);
  }

  componentDidMount() {
    // if (this.state.origin === null) this.position();
  }

  updateLocation(lat, lng) {
    this.setState({
      lat,
      lng,
      selectedLocation: {
        lat: lat,
        lng: lng
      }
    });
  }

  resetSelectedLocation() {
    this.setState({
      selectedLocation: null
    });
  }

  updateBounds(restaurantsInBounds) {
    // console.log("updateBounds ==>>>");
    this.setState({ restaurantsInBounds });
  }

  position = async () => {
    await navigator.geolocation.getCurrentPosition(position =>
      this.setState({
        origin: {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }
      })
    );
  };

  setDestination = (lat, lng) => {
    // console.log("SET DESTINATION");
    this.setState({
      destination: {
        lat: lat,
        lng: lng
      }
    });
  };

  resetDestination = () => {
    // console.log("RESET DESTINATION");
    this.setState({
      destination: null
    });
  };

  setDestinationAndClose(lat, lng) {
    // console.log("Set directions ==>>>");
    this.setState(
      {
        destination: {
          lat: lat,
          lng: lng
        }
      },
      this.onClose
    );
  }

  onRestaurantSelect(restaurant, event) {
    if (event.target.name != "reserve-button") {
      this.setState({
        selectedRestaurant: restaurant,
        lat: restaurant.latitude,
        lng: restaurant.longitude,
        destination: null
      });
    }
  }

  getSelectedRestaurantId(id) {
    this.setState({
      selectedRestaurantId: id
    });
  }

  resetSelectedRestaurantId() {
    // console.log("resetSelectedRestaurantId");
    this.setState({
      selectedRestaurantId: null
    });
  }

  openLink(url) {
    // console.log("OPEN LINK");
    // console.log(url);
    if (url !== null) {
      window.open(url, "_blank");
    }
  }

  onClose() {
    // console.log("onClose ==>>>");
    this.setState({
      selectedRestaurant: null
      // destination: null
    });
  }

  onMarkerClick = (marker, e) => {
    this.setState({
      selectedRestaurant: marker.restaurant,
      lat: marker.position.lat,
      lng: marker.position.lng,
      destination: null
    });
  };

  render() {
    const { lat, lng, restaurantsInBounds } = this.state;
    return (
      <Wrapper id="patio-finder">
        <div className="detail-container">
          <div className="list-background-image" />
          <div className="input-background-image" />
          <div className="input-container">
            <h2 className="input-title">
              TROUVER UNE TERRASSE
              <br />
              PRÈS DE VOUS
            </h2>
            {this.state.selectedRestaurant !== null &&
            this.props.innerWidth < 768 ? (
              <button
                className="map-button yellow-button"
                onClick={this.onClose}
              >
                CARTE
              </button>
            ) : (
              <div>
                <SearchBox updateLocation={this.updateLocation} />
                <LocateMeButton
                  label="ME LOCALISER"
                  updateLocation={this.updateLocation}
                />
              </div>
            )}
          </div>

          {this.state.selectedRestaurant && this.props.innerWidth < 768 ? (
            <RestaurantDetail
              innerWidth={this.props.innerWidth}
              openLink={this.openLink}
              onClose={this.onClose}
              restaurant={this.state.selectedRestaurant}
              setDestinationAndClose={this.setDestinationAndClose}
            />
          ) : (
            <div />
          )}

          {this.props.innerWidth < 768 ? (
            <div
              className="map-container"
              style={{
                opacity: this.state.selectedRestaurant === null ? "1" : "0",
                marginBottom:
                  this.state.selectedRestaurant === null ? "0px" : "-463px"
              }}
            >
              <GoogleMap
                initialCenter={{
                  lat: TORONTO_CENTER.lat,
                  lng: TORONTO_CENTER.lng
                }}
                center={{
                  lat: this.state.lat,
                  lng: this.state.lng
                }}
                mapStyle={MAP_STYLE_MOBILE}
                mapType={"terrain"}
                defaultZoom={14}
                origin={this.state.origin}
                destination={this.state.destination}
                updateBounds={this.updateBounds}
                restaurantListings={this.restaurantListings}
                updateLocation={this.updateLocation}
                setDestination={this.setDestination}
                resetDestination={this.resetDestination}
                selectedLocation={this.state.selectedLocation}
                resetSelectedLocation={this.resetSelectedLocation}
                innerWidth={this.props.innerWidth}
                yesIWantToUseGoogleMapApiInternals
              >
                <Markers
                  restaurantData={this.restaurantListings}
                  onMarkerClick={this.onMarkerClick}
                  url={MARKER_ICON}
                />
              </GoogleMap>
            </div>
          ) : (
            <div />
          )}

          <div className="mask-group">
            <div className="texture-layer" />
          </div>
          <div className="restaurant-list-container">
            {this.props.innerWidth < 768 ? (
              <RestaurantList
                openLink={this.openLink}
                onRestaurantSelect={this.onRestaurantSelect}
                innerWidth={this.props.innerWidth}
                restaurants={restaurantsInBounds}
              />
            ) : (
              <RestaurantList
                openLink={this.openLink}
                getSelectedRestaurantId={this.getSelectedRestaurantId}
                innerWidth={this.props.innerWidth}
                restaurants={restaurantsInBounds}
              />
            )}
          </div>
        </div>
        {this.props.innerWidth >= 768 ? (
          <div className="map-container">
            <GoogleMap
              restaurantsInBounds={restaurantsInBounds}
              initialCenter={{
                lat: TORONTO_CENTER.lat,
                lng: TORONTO_CENTER.lng
              }}
              center={this.state.center}
              mapStyle={MAP_STYLE}
              mapType={"roadmap"}
              defaultZoom={14}
              origin={this.state.origin}
              destination={this.state.destination}
              updateBounds={this.updateBounds}
              restaurantListings={this.restaurantListings}
              updateLocation={this.updateLocation}
              innerWidth={this.props.innerWidth}
              openLink={this.openLink}
              setDestination={this.setDestination}
              resetDestination={this.resetDestination}
              selectedLocation={this.state.selectedLocation}
              resetSelectedLocation={this.resetSelectedLocation}
              selectedRestaurantId={this.state.selectedRestaurantId}
              resetSelectedRestaurantId={this.resetSelectedRestaurantId}
              yesIWantToUseGoogleMapApiInternals
            />

            {this.state.selectedRestaurant ? (
              <RestaurantDetail
                innerWidth={this.props.innerWidth}
                openLink={this.openLink}
                restaurant={this.state.selectedRestaurant}
              />
            ) : (
              <div />
            )}
          </div>
        ) : (
          <div />
        )}
      </Wrapper>
    );
  }
}

export default PatioFinder;
